<template>
  <px-custom-dialog v-model="dialog" width="700">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Usuário
    </template>
    <template v-if="dialog">
      <div class="text--primary mt-5" v-if="user">
        <div class="body-1 mb-5">
          Editando senha do usuário: {{ user.nome }} - {{user.email}}
        </div>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              label="Senha"
              class="required"
              type="password"
              minlength="8"
              maxlength="30"
              :messages="passwordMessages"
              autocomplete="new-password"
              :error="$v.user.password.$error"
              @blur="$v.user.password.$touch()"
              v-model="user.password"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              label="Repetir senha"
              class="required"
              type="password"
              minlength="8"
              maxlength="30"
              autocomplete="new-password"
              :error="$v.user.matchPassword.$error"
              @blur="$v.user.matchPassword.$touch()"
              v-model="user.matchPassword"
            />
          </v-col>
        </v-row>
      </div>
    </template>
    <template v-slot:actions>
      <v-spacer/>
      <v-btn @click="close">
        Cancelar
      </v-btn>
      <v-btn color="primary"
             :loading="loading"
             @click="salvar">
        Enviar
      </v-btn>
    </template>
  </px-custom-dialog>
</template>

<script>
import { clone } from 'lodash';
import {
  maxLength,
  minLength,
  required,
  sameAs,
} from 'vuelidate/lib/validators';
import { isPasswordValid } from '@/utils/validate-password';
import UsuarioService from '../usuario-service';


export default {
  props: {
    usuario: Object,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      passwordMessages: ['Deve possuir letra maiúscula, minúscula e números. Entre 8 e 30 caracteres'],
      user: null,
    };
  },
  methods: {
    buildPayload() {
      return {
        id: this.user.id,
        newPassword: this.user.password,
        matchPassword: this.user.matchPassword,
      };
    },
    salvar() {
      this.loading = true;
      UsuarioService.changePassword(this.user.id, this.buildPayload())
        .then(() => {
          this.$toast('Usuário salvo', { color: 'success' });
          this.$emit('update');
          this.close();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.dialog = false;
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.user = null;
        return;
      }
      if (this.usuario) {
        this.user = clone(this.usuario);
      }
    },
  },
  validations: {
    user: {
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(30),
        passwordValid(value) {
          return isPasswordValid(value);
        },
      },
      matchPassword: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
  },
};
</script>
